module.exports = __webpack_public_path__ + "media/images/category/feature/aoj_e/logo-aoj-en-aaebcbfaf2c59a02ebd2ddf9d5f47568.svg";